class NumbersHelper {
  commaFormat(value) {
    return Number(value).toLocaleString('fr-FR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }
  toFixed(x) {
    if (Math.abs(x) < 1.0) {
      let e = parseInt(x.toString().split('e-')[1]);
      if (e) {
        x *= Math.pow(10, e - 1);
        x = '0.' + new Array(e).join('0') + x.toString().substring(2);
      }
    } else {
      let e = parseInt(x.toString().split('+')[1]);
      if (e > 20) {
        e -= 20;
        x /= Math.pow(10, e);
        x += new Array(e + 1).join('0');
      }
    }
    return x;
  }
  toFixedTrunc(x, n) {
    x = this.toFixed(x);

    const v = (typeof x === 'string' ? x : x.toString()).split('.');
    if (n <= 0) return v[0];
    let f = v[1] || '';
    if (f.length > n) return `${v[0]}.${f.substr(0, n)}`;
    while (f.length < n) f += '0';
    return Number(`${v[0]}.${f}`);
  }
  // max fixed is to 2 numbers after decimal
  toFixedTruncMoney(x, n) {
    x = this.toFixed(x);

    const v = (typeof x === 'string' ? x : x.toString()).split('.');
    if (n <= 0) return v[0];
    let f = v[1] || '';
    // round 3 or more numbers after decimal
    if (f.length > 2) {
      let f2 = f.substring(0, 2);
      if (f2[2] >= 5) {
        f = parseInt(f2[0] + '' + f2[1]) + 1;
      }
    }

    if (f.length > n) return `${v[0]}.${f.substr(0, n)}`;
    while (f.length < n) f += '0';
    return Number(`${v[0]}.${f}`);
  }
}

export default new NumbersHelper();
